import './styles/custom.scss';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './components/About';
import Contact from './components/Contact';
import FeaturedBooks from './components/FeaturedBooks';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './pages/Home';
import Promo from './pages/Promo';
import React from 'react';

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/promo/comunion" element={<Promo />} />
                <Route path="/about" element={<About />} />
                <Route path="/books" element={<FeaturedBooks />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;